import { Areas } from "@/business/ComponentViews/AreaInfoDataSet";

export class AreaStore {

  public static getDataSet( store: any) : Areas {
    return store.getters["areastore/getDataSet"];
  
  }

  public static setDataSet( store: any, payload: Areas) {
    store.commit("areastore/addDataSet" , payload)
  }

}

export const areastore = {
  namespaced: true,
  state: {
    areaInfo: {
      areas: [],
    }
  },
  mutations: {
    addDataSet(state: any, payload: Areas) {
      state.areaInfo = payload;
    }
  },
  actions: {},
  getters: {
    getDataSet: function(state: any): Areas {
      return state.areaInfo;
    }
  }
};

// type Areas
// this._store.getters["areastore/getDataSet"]
// _store.commit("areastore/addDataSet", areaInfo)